/**
 * Variant media filter (ALT text method)
 * Shows/hides product gallery media based on selected variant option (e.g. Color).
 * Set image ALT text like: "Brown - front", "Light Brown - back", or "light_brown_1".
 * Underscores in ALT are treated as spaces when matching (so "light_brown" matches variant "Light Brown").
 * Use ALT "all" for images that should always show (e.g. size chart).
 */
(function () {
  function normalize(str) {
    return (str || "")
      .toString()
      .trim()
      .toLowerCase();
  }

  function normalizeForMatch(str) {
    return normalize(str).replace(/_/g, " ");
  }

  function getSelectedVariantText() {
    const picker = document.querySelector("variant-picker");
    if (!picker) return "";

    const checkedRadio = picker.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return checkedRadio.value;

    const select = picker.querySelector("select.variant-option__select");
    return select ? select.value : "";
  }

  function itemMatchesVariant(item, selected, selectedMatch) {
    const group = normalize(item.getAttribute("data-variant-group") || "");
    if (group === "all" || group === "") return true;
    if (!selected) return true;
    const groupMatch = normalizeForMatch(group);
    return (
      groupMatch === selectedMatch ||
      groupMatch.startsWith(selectedMatch + " ") ||
      groupMatch.startsWith(selectedMatch + "-") ||
      groupMatch.startsWith(selectedMatch + "_")
    );
  }

  function filterMedia() {
    const selected = normalize(getSelectedVariantText());
    const selectedMatch = normalizeForMatch(selected);
    const items = document.querySelectorAll(
      ".product-media-item[data-variant-group]"
    );
    if (!items.length) return;

    items.forEach((item) => {
      const matches = itemMatchesVariant(item, selected, selectedMatch);
      item.style.display = matches ? "" : "none";
      if (matches) {
        item.removeAttribute("hidden");
      } else {
        item.setAttribute("hidden", "");
      }
    });

    reorderSlideshowSlidesAndDots(selected, selectedMatch);
  }

  function reorderSlideshowSlidesAndDots(selected, selectedMatch) {
    const gallery = document.querySelector("media-gallery");
    if (!gallery) return;

    const slideshow = gallery.querySelector("slideshow-component");
    if (!slideshow) return;

    const slidesContainer = slideshow.querySelector("slideshow-slides");
    const controls = slideshow.querySelector("slideshow-controls");
    if (!slidesContainer || !controls) return;

    const slideEls = Array.from(slidesContainer.children).filter((el) =>
      el.classList.contains("product-media-item")
    );
    const dotsList = controls.querySelector("ol.slideshow-controls__dots");
    const thumbnailsContainer = controls.querySelector(
      ".slideshow-controls__thumbnails"
    );
    const dotLis = dotsList ? Array.from(dotsList.children) : [];
    const thumbnailButtons = thumbnailsContainer
      ? Array.from(thumbnailsContainer.querySelectorAll("button"))
      : [];
    const controlItems =
      dotLis.length === slideEls.length
        ? dotLis
        : thumbnailButtons.length === slideEls.length
          ? thumbnailButtons
          : [];
    if (slideEls.length === 0 || controlItems.length !== slideEls.length) return;
    const controlsParent = dotsList || thumbnailsContainer;

    const visibleIndices = [];
    const hiddenIndices = [];
    for (let i = 0; i < slideEls.length; i++) {
      if (itemMatchesVariant(slideEls[i], selected, selectedMatch)) {
        visibleIndices.push(i);
      } else {
        hiddenIndices.push(i);
      }
    }

    if (hiddenIndices.length === 0) {
      slideEls.forEach((s) => {
        s.style.display = "";
        s.removeAttribute("hidden");
      });
      controlItems.forEach((el) => {
        el.style.display = "";
      });
      return;
    }

    const newOrder = visibleIndices.concat(hiddenIndices);
    const orderedSlides = newOrder.map((i) => slideEls[i]);
    const orderedControls = newOrder.map((i) => controlItems[i]);

    newOrder.forEach((originalIndex, newIndex) => {
      const slide = slideEls[originalIndex];
      const ctrl = controlItems[originalIndex];
      const isVisible = newIndex < visibleIndices.length;
      slide.style.display = isVisible ? "" : "none";
      if (isVisible) {
        slide.removeAttribute("hidden");
      } else {
        slide.setAttribute("hidden", "");
      }
      if (ctrl) {
        ctrl.style.display = isVisible ? "" : "none";
      }
    });

    orderedSlides.forEach((slide) => slidesContainer.appendChild(slide));
    orderedControls.forEach((el) => controlsParent.appendChild(el));

    if (typeof slideshow.select === "function") {
      slideshow.select(0, undefined, { animate: false });
    }
  }

  function runFilterAfterGalleryUpdate() {
    setTimeout(filterMedia, 0);
  }

  document.addEventListener("DOMContentLoaded", function () {
    filterMedia();

    document.addEventListener("change", function (e) {
      if (e.target?.closest("variant-picker")) filterMedia();
    });

    document.addEventListener("variant:update", runFilterAfterGalleryUpdate);
  });
})();
